import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const initialState = {
  data: [],
  loading: false,
  errorMessage: "",
};

export const fetchAd = createAsyncThunk(`ad/fetchAd`, async () => {
  const response = await api.get("advertisement/");
  return response.data;
});

const adSlice = createSlice({
  name: "ad",
  initialState,
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(fetchAd.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAd.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      });
  },
});

export default adSlice.reducer;
